.section-title {
  color: var(--chart-300-icon-buttons);

  &.disabled {
    color: var(--grey-layout-200-disabled);
  }
}

gz-labeled-content {
  gz-checkbox {
    display: block;
  }

  &.disabled::part(label) {
    color: var(--grey-layout-200-disabled);
  }
}
